import React from 'react'
import styled from 'styled-components';

import bg from '../assets/login_bg.png';

import { LoginBox } from '../components/login'

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0
    left: 0;
    right: 0;
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
`

const Overlay = styled.div`
    background-color: ${props => props.theme.colors.primary}
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`
const BoxWrapper = styled.div`
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;
`

const LoginPage = ({ multistore }) => {

    console.log("Teste pipeline branch homolog + CD")
    return (
        <Wrapper>
            <Overlay />
            <BoxWrapper>
                <LoginBox multistore={multistore} />
            </BoxWrapper>
        </Wrapper>
    )
}

export default LoginPage